import * as React from 'react';
import { act, render, screen } from '@testing-library/react';
import TimerButton from './TimerButton';

jest.mock('components/styleguide/icon/Icon', () => ({
  __esModule: true,
  default: ({ name, ...props }: any) => <span data-icon={name} {...props} />,
}));

describe('TimerButton', () => {
  beforeEach(() => {
    jest.useFakeTimers();
  });

  afterEach(() => {
    jest.useRealTimers();
  });

  it('renders disabled with a countdown suffix while ticking', () => {
    render(<TimerButton initialSeconds={10}>Resend</TimerButton>);

    const button = screen.getByRole('button');
    expect(button).toBeDisabled();
    expect(button).toHaveTextContent('Resend (10s)');
  });

  it('updates the countdown as time passes', () => {
    render(<TimerButton initialSeconds={5}>Resend</TimerButton>);

    act(() => { jest.advanceTimersByTime(2000); });

    expect(screen.getByRole('button')).toHaveTextContent('Resend (3s)');
  });

  it('enables the button and drops the suffix when the timer reaches 0', () => {
    render(<TimerButton initialSeconds={2}>Resend</TimerButton>);

    act(() => { jest.advanceTimersByTime(2000); });

    const button = screen.getByRole('button');
    expect(button).not.toBeDisabled();
    expect(button).toHaveTextContent('Resend');
    expect(button.textContent).not.toMatch(/\(\d+s\)/);
  });

  it('calls onTimerComplete when the timer finishes', () => {
    const onComplete = jest.fn();
    render(
      <TimerButton initialSeconds={2} onTimerComplete={onComplete}>Resend</TimerButton>
    );

    expect(onComplete).not.toHaveBeenCalled();
    act(() => { jest.advanceTimersByTime(2000); });

    expect(onComplete).toHaveBeenCalledTimes(1);
  });

  it('is enabled immediately and fires onTimerComplete when initialSeconds is 0', () => {
    const onComplete = jest.fn();
    render(
      <TimerButton initialSeconds={0} onTimerComplete={onComplete}>Resend</TimerButton>
    );

    expect(screen.getByRole('button')).not.toBeDisabled();
    expect(onComplete).toHaveBeenCalledTimes(1);
  });

  it('stays disabled after the timer ends if the caller also passes disabled', () => {
    render(<TimerButton initialSeconds={1} disabled>Resend</TimerButton>);

    act(() => { jest.advanceTimersByTime(1000); });

    expect(screen.getByRole('button')).toBeDisabled();
  });
});
